module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "write-box"
  }, [_c('van-field', {
    attrs: {
      "rows": "5",
      "autosize": "",
      "label": "",
      "type": "textarea",
      "placeholder": "请输入评价内容",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('PicUploader', {
    attrs: {
      "fileList": _vm.formData.pics,
      "limit": 9,
      "name": 'pics'
    },
    on: {
      "imageListChange": _vm.imageListChange
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "star-box"
  }, [_c('div', {
    staticClass: "star-title"
  }, [_vm._v("请选择星级")]), _vm._v(" "), _c('van-rate', {
    attrs: {
      "size": 25,
      "color": "#ffd21e",
      "void-icon": "star",
      "void-color": "#eee"
    },
    model: {
      value: (_vm.formData.star),
      callback: function($$v) {
        _vm.$set(_vm.formData, "star", $$v)
      },
      expression: "formData.star"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "submit-box"
  }, [_c('div', {
    staticClass: "submit-btn",
    on: {
      "click": _vm.submit
    }
  }, [_c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    }
  }, [_vm._v("发表评论")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-822d7156","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/order/OrderCommentOperate.vue
// module id = 2510
// module chunks = 0